import React from "react";
import { Grid, Container, Paper } from "@material-ui/core";
import {
  Button,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import logo from "../Assets/login/RockkpayLogo.png";
import { Colors } from "./Colors";

const PayinReportInvoice = ({ data }) => {
  const userID = sessionStorage.getItem("userId");
  const userName = sessionStorage.getItem("username");

  if (!data) return null;

  console.log("Generating PDF for transaction:", data.txnid);

  return (
    <Container
      style={{
        padding: "1rem",
        width: "100%",
        maxWidth: "1000px",
        boxSizing: "border-box",
        backgroundColor: "#f0f0f0", // Set the background color here
        minHeight: "90vh", // Ensure the background color covers the full height
        borderRadius: "14px",
      }}
    >
      <Paper
        elevation={3}
        style={{
          paddingTop: "5%",
          padding: "2rem",
          backgroundColor: Colors.bgColor,
          boxSizing: "border-box",
          color: Colors.textColor,
        }}
      >
        <Grid style={{ display: "flex", justifyContent: "center" }}>
          <Typography
            style={{ fontSize: "18px", fontWeight: "bold", marginTop: "-2%" }}
          >
            Payin Receipt{" "}
          </Typography>
        </Grid>
        <Grid style={{ marginTop: "1%" }}>
          <Grid
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Grid style={{ display: "flex", alignItems: "center", gap: "6%" }}>
              <img
                src={logo}
                alt="RockkPay Logo"
                style={{
                  height: 65,
                  width: 65,
                  backgroundColor: "transparent",
                  borderRadius: "50%",
                }}
              />
              <Typography style={{ fontWeight: "bold", fontSize: "28px" }}>
                RockkPay
              </Typography>
            </Grid>
            <Typography style={{ fontWeight: "bold", fontSize: "20px" }}>
              EDSOM FINTECH PRIVATE LIMITED
            </Typography>
          </Grid>
          <Grid
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Grid style={{ marginTop: "1%" }}>
              <Typography
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  textAlign: "start",
                }}
              >
                {new Date(data.addedon).toLocaleDateString() || "N/A"}
              </Typography>
              <Typography
                style={{
                  fontSize: "14px",
                  fontWeight: "bold",
                  textAlign: "start",
                }}
              >
                {new Date(data.addedon).toLocaleTimeString() || "N/A"}
              </Typography>
            </Grid>
            <Grid>
              <Typography style={{ fontSize: "14px", textAlign: "end" }}>
                201, BANER ROAD, PUNE, MAHARASHTRA - 411045
              </Typography>
              <Typography style={{ fontSize: "14px", textAlign: "end" }}>
                edsomfintech@gmail.com
              </Typography>
              <Typography
                style={{
                  fontSize: "16px",
                  textAlign: "end",
                  fontWeight: "bold",
                }}
              >
                {userName}
              </Typography>
              <Typography
                style={{
                  fontSize: "14px",
                  textAlign: "end",
                  fontWeight: "bold",
                }}
              >
                UID : {userID}
              </Typography>
            </Grid>
          </Grid>
          <TableContainer style={{ marginTop: "5%" }}>
            <Table
              aria-label="transaction table"
              style={{ tableLayout: "fixed", width: "100%" }}
            >
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      fontWeight: "bold",
                      width: "10%",
                      fontSize: "12px",
                      color: Colors.textColor,
                    }}
                  >
                    Txn ID
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: "bold",
                      width: "10%",
                      fontSize: "12px",
                      color: Colors.textColor,
                      paddingLeft: "3%",
                    }}
                  >
                    UTR No.
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: "bold",
                      width: "10%",
                      fontSize: "12px",
                      color: Colors.textColor,
                      paddingLeft: "5%",
                    }}
                  >
                    Amount
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: "bold",
                      width: "10%",
                      fontSize: "12px",
                      color: Colors.textColor,
                    }}
                  >
                    Payment Type
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: "bold",
                      width: "10%",
                      fontSize: "12px",
                      color: Colors.textColor,
                    }}
                  >
                    Payment By
                  </TableCell>
                  <TableCell
                    style={{
                      fontWeight: "bold",
                      width: "10%",
                      fontSize: "12px",
                      color: Colors.textColor,
                      paddingLeft: "5%",
                    }}
                  >
                    Status
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell
                    style={{ fontSize: "12px", color: Colors.textColor }}
                  >
                    {data.txnid || "N/A"}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "12px",
                      color: Colors.textColor,
                      paddingLeft: "3%",
                    }}
                  >
                    {data.easepayid || "N/A"}
                  </TableCell>
                  <TableCell
                    style={{
                      fontSize: "12px",
                      color: Colors.textColor,
                      paddingLeft: "5%",
                    }}
                  >
                    {data.amount || "N/A"}
                  </TableCell>
                  <TableCell
                    style={{ fontSize: "12px", color: Colors.textColor }}
                  >
                    {data.cardType}
                  </TableCell>
                  {/* Conditional rendering for "Payment By" based on cardType */}
                  {data.cardType === "UPI" ? (
                    <TableCell
                      style={{ fontSize: "12px", color: Colors.textColor }}
                    >
                      {data.upiVa || "N/A"}
                    </TableCell> // Payment By UPI
                  ) : data.cardType === "Credit Card" ||
                    data.cardType === "Debit Card" ? (
                    <TableCell
                      style={{ fontSize: "12px", color: Colors.textColor }}
                    >
                      {data.cardnum || "N/A"}
                    </TableCell> // Payment By Card Number
                  ) : (
                    <TableCell
                      style={{ fontSize: "12px", color: Colors.textColor }}
                    >
                      N/A
                    </TableCell> // Handle other card types if necessary
                  )}
                  <TableCell
                    style={{
                      fontSize: "12px",
                      color: Colors.textColor,
                      paddingLeft: "5%",
                    }}
                  >
                    {data.status === "success"
                      ? "Successful"
                      : data.status === "failure"
                        ? "Failed"
                        : data.status === "userCancelled"
                          ? "User Cancelled"
                          : data.status === "preinitiated"
                            ? "Preinitiated"
                            : data.status || "N/A"}{" "}
                    {/* Default value if no match */}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Grid
            style={{
              marginTop: "4%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Grid>
              <Typography style={{ fontWeight: "bold", fontSize: "20px" }}>
                Thank you for transacting at RockkPay!
              </Typography>
              <Typography
                color="textSecondary"
                style={{ fontSize: "12px", color: Colors.textColor }}
              >
                This is a system generated receipt hence does not require any
                signature.
              </Typography>
              <Typography
                color="textSecondary"
                style={{ fontSize: "12px", color: Colors.textColor }}
              >
                Queries? Write to care@rockkpay.co.in
              </Typography>
            </Grid>
            <Grid>
              <Divider />
              <Grid>
                <Typography style={{ fontWeight: "bold" }}>
                  Total Amount : {data.amount}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

export default PayinReportInvoice;
